import { createEvent, restore, sample } from 'effector'
import { fx } from 'src/libs'
import {
  ApiListResponse,
  Dividend,
  DividendFilter,
} from 'src/pages/finSystem/balanceSummary/reports/reportDividends/types'
import { normalizeObject } from 'src/pages/finSystem/balanceSummary/reports/utils'

export const dividendListLoad = createEvent<DividendFilter>()

export const getDividendListFx = fx<any | void, ApiListResponse<Dividend>>({
  method: 'GET',
  url: `/finance/report/dividend`,
})

export const $dividendList = restore<ApiListResponse<Dividend>>(
  getDividendListFx.doneData.map((res) => res.body),
  null,
)

export const $walletOptions = $dividendList.map((data) => {
  if (!data) return []

  const map = new Map<number, { label: string; value: string }>()

  data.items.forEach((item) => {
    if (!map.has(item.walletId)) {
      map.set(item.walletId, {
        label: item.walletName,
        value: String(item.walletId),
      })
    }
  })
  return Array.from(map.values())
})

sample({
  clock: dividendListLoad,
  fn: (filters) => {
    const requestObject = normalizeObject(filters)

    if (!requestObject || Object.keys(requestObject).length === 0) {
      return {}
    }
    const query: any = {}

    const { sorterField, search, ...rest } = requestObject

    if (sorterField) query['order'] = requestObject.sorterField
    if (search) query['search'] = requestObject.search

    if (Object.keys(rest).length !== 0) query['where'] = JSON.stringify(rest)

    return { query }
  },
  target: getDividendListFx,
})
